import { Injectable, isDevMode } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';
import { DataService } from './data.service';

@Injectable()
export class AuthenticationService {
    private serverBase: string;

    constructor(private _http: HttpClient, private dataService: DataService) {
        this.serverBase = environment.serverBase;
    }

    private updateHomeLink(val: boolean) {
        this.dataService.homeLinkSubject.next(val);
    }

    login(username: string, password: string) {
        const body = {
            'username': username,
            'password': password
        };
        const options = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
        };
        return this._http.post(
            this.serverBase + '/api/login',
            body,
            options
        ).map(
            (data: { data: any, response: string, response_message: Array<any> }) => {
                if (data.response === 'success') {
                    if (data && data.data) {
                        localStorage.setItem('token', data.data);
                        this.updateHomeLink(true);
                    }
                    return data;
                }
            })
            .catch(error => Observable.throw(error || 'Internal server error')
            );
    }

    autoLogin(token: string) {
        if (!!token) {
            localStorage.setItem('token', token);
            this.updateHomeLink(true);
        }
    }

    async logout(params: any = {}): Promise<any> {
        return new Promise((res, rej) => {
            if (this.isLoggedIn()) {
                const options = {
                    headers: new HttpHeaders()
                        .set('Authorization', 'bearer ' + this.getToken())
                        .set('Content-Type', 'application/json')
                };
                (this._http.get(
                    this.serverBase + '/auth/logout',
                    options
                ).map(response => {
                    if (response) {
                        return response;
                    }
                }).catch((error: HttpErrorResponse) => {
                    console.log(error);
                    return Observable.throw(error || 'Internal server error');
                })).subscribe((d: any) => {
                    if (isDevMode) { console.log('Logged Out'); }
                    localStorage.removeItem('token');
                    sessionStorage.removeItem('productListCache');
                    this.updateHomeLink(false);
                    this.dataService.searchTextSubject.next('');

                    res({ status: 'success' });
                }, (e: any) => {
                    console.error(`Error while logging out: ${e}`);
                    res({ status: 'failure' });
                });
            } else {
                res({ status: 'already_logged_out' });
            }
        });
    }

    getToken(): string {
        return localStorage.getItem('token');
    }

    isLoggedIn(): boolean {
        const isLoggedIn = localStorage.getItem('token');
        return (isLoggedIn ? true : false);
    }

    getUserInfo() {
        const userToken = this.getToken();
        if (userToken) {
            let payload = userToken.split('.')[1];
            payload = atob(payload);
            payload = JSON.parse(payload);
            return payload;
        }
        return false;
    }

    getRole(): string {
        const userInfo = this.getUserInfo();
        if (userInfo) {
            return userInfo['role'] || '';
        } else {
            return null;
        }
    }

    getUserID() {
        const userID = this.getUserInfo();
        if (userID) {
            return userID['userID'] || '';
        } else {
            return null;
        }
    }

    isAuthorized(authorizedRoles) {
        return authorizedRoles.length ? _.indexOf(authorizedRoles, this.getRole()) >= 0 : true;
    }

    _errorHandler(error: any) {
        console.log(error);
        return Observable.throw(error || 'Internal server error');
    }
}



// WEBPACK FOOTER //
// ./public/app/_services/authentication.service.ts